import { render, staticRenderFns } from "./MolecularTestRuns.vue?vue&type=template&id=5c9ea641&scoped=true&"
import script from "./MolecularTestRuns.vue?vue&type=script&lang=js&"
export * from "./MolecularTestRuns.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c9ea641",
  null
  
)

export default component.exports